import { measureNodeLabel } from '@ardoq/graph-labeling';
import { MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES } from 'yfilesExtensions/styles/modernized/consts';
import { MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_LABEL_WIDTH as LABEL_WIDTH } from '../consts';
import { wrapString } from 'tabview/blocks/misc/string';

const wrapLeafNodeLabel = (text: string) =>
  wrapString(text, LABEL_WIDTH, measureNodeLabel, MAX_LINES);
export { wrapLeafNodeLabel };
